/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react"
import TagManager from "react-gtm-module"
import { isMobile } from "react-device-detect"

import { JS, CONFIG, EVENT, CONVERSION, EN, CA, DE, IT, BR, FI, IN, ES, NZ, PE, CL, JP, FR, AFR, HN, SE, SV } from "./constants"
import translations from "./translations"
import { ReactComponent as SignUpIcon } from "../assets/icons/signup.svg"
import { ReactComponent as SlotIcon } from "../assets/icons/slot.svg"

const {
  REACT_APP_GTM_ID: gtmId,
  REACT_APP_LMBAS_API: apiUrl,
  REACT_APP_MARKET_UID: marketUId,
  REACT_APP_DOMAIN_ZONE: domainZone,
  REACT_APP_CODE: siteCode,
  REACT_APP_LOBBY_URL: lobbyUrl
  // REACT_APP_MEDIA_URL: mediaUrl
} = process.env

const getPage = (pages, pageId) => {
  if (!pageId) {
    return undefined
  }
  return pages.find(page => page.slug === pageId)
}

const removeLeadingSlash = str => (str[0] === "/" ? str.slice(1) : str)

export const initialize = () => {
  TagManager.initialize({
    gtmId,
    dataLayer: []
  })
}

const pushDatalayer = (event, category, action, label) => {
  if (!window.dataLayer) {
    return
  }

  window.dataLayer.push({
    event,
    category,
    action,
    label
  })
}

const addGtm = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    originalLocation: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`
  })
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js"
    })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s)
    const dl = l !== "dataLayer" ? `&l=${l}` : ""
    j.async = true
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
    f.parentNode.insertBefore(j, f)
  })(window, document, "script", "dataLayer", gtmId)
}

const addGtag = (gtagId, gtagHash) => {
  window.dataLayer = window.dataLayer || []

  function gtag() {
    window.dataLayer.push(arguments)
  }

  gtag(JS, new Date())

  gtag(CONFIG, gtagId)

  gtag(EVENT, CONVERSION, { send_to: `${gtagId}/${gtagHash}` })
}

const loadingEvent = (condition, callback) => condition && callback && callback()

const loadingHandler = (...args) => args.forEach(arg => arg)

const handleSuccess = () => {}

const handleError = error => {
  // eslint-disable-next-line no-console
  console.log("--- Error: ", error.message)
}
const isUrl = s => {
  const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/
  return regexp.test(s)
}

const getFont = brand => {
  switch (brand) {
    case "leovegasf2p":
      return "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;0,900;1,400;1,500;1,700;1,900&display=swap"
    case "royalpanda":
      return "https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap"
    default:
      return "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;0,900;1,400;1,500;1,700;1,900&display=swap"
  }
}

const getBannerFont = brand => {
  switch (brand) {
    case "gogocasino":
      return "../assets/gogocasino/fonts/Black-Slabbath.woff"
    case "livecasino":
      return "../../assets/livecasino/fonts/WulkanDisplay-Bold.woff"
    default:
      return null
  }
}

const getLang = country => {
  switch (country) {
    case CA:
      return EN
    case FR:
      return FR
    case NZ:
    case AFR:
      return EN
    case DE:
      return DE
    case IT:
      return IT
    case BR:
      return BR
    case FI:
      return FI
    case SE:
      return SE
    case JP:
      return JP
    case IN:
      return IN
    case CL:
    case PE:
    case HN:
    case SV:
      return ES
    default:
      return EN
  }
}

const getTranslations = lang => {
  const language = getLang(lang)
  return translations[language]
}

const getCleanObject = obj => {
  if (Array.isArray(obj)) {
    // Clean each element and filter out null/empty
    const arr = obj.map(getCleanObject).filter(item => item !== null && item !== undefined)

    return arr.length > 0 ? arr : null // remove empty arrays
  }
  if (obj !== null && typeof obj === "object") {
    // Clean each property
    const cleanedObj = Object.entries(obj).reduce((acc, [key, value]) => {
      const cleaned = getCleanObject(value)
      if (cleaned !== null && cleaned !== undefined) {
        acc[key] = cleaned
      }
      return acc
    }, {})

    return Object.keys(cleanedObj).length > 0 ? cleanedObj : null // remove empty objects
  }
  return obj // return primitive (string, number, boolean)
}

const getMenuIcon = item => {
  switch (item) {
    case "games":
      return <SlotIcon />
    case "signUp":
      return <SignUpIcon />
    default:
      return <SlotIcon />
  }
}

export function pushConsentToDataLayer() {
  // eslint-disable-next-line prefer-rest-params
  dataLayer.push(arguments)
}

const useCookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false)
  const [shouldLoadGtm, setShouldLoadGtm] = useState(false)

  const createExpiryDate = () => {
    const expiryDate = new Date()
    expiryDate.setDate(expiryDate.getDate() + 183)
    return expiryDate
  }

  const loadMarketingScript = () => {
    if (document.getElementById("nurtigo-script")) return

    const script = document.createElement("script")
    script.id = "nurtigo-script"
    script.type = "text/javascript"

    script.innerHTML = `
    (function(w,d,t,u,n,a,m){w['NurtigoTrackingObject']=n;
      w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)},a=d.createElement(t),
      m=d.getElementsByTagName(t)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m)
      })(window,document,
      'script'
      ,
      'https://leovegas.app.nurtigo.cloud/mtc.js'
      ,
      'mt');
      mt('send'
      ,
      'pageview');
  `

    document.head.appendChild(script)
  }

  const accept = consent => {
    const gtagConsentMode = {
      security_storage: consent.necessary ? "granted" : "denied",
      functionality_storage: consent.functional ? "granted" : "denied",
      ad_storage: consent.marketing ? "granted" : "denied",
      analytics_storage: consent.analytics ? "granted" : "denied",
      personalization_storage: consent.necessary ? "granted" : "denied",
      ad_user_data: consent.marketing ? "granted" : "denied",
      ad_personalization: consent.marketing ? "granted" : "denied"
    }

    const lsConsentMode = {
      ...gtagConsentMode,
      expiry: createExpiryDate()
    }

    pushConsentToDataLayer("consent", "update", gtagConsentMode)

    localStorage.setItem("consentMode", JSON.stringify(lsConsentMode))

    if (domainZone === "it" && consent.marketing) {
      loadMarketingScript()
    }

    setShowConsent(false)
    setShouldLoadGtm(true)
  }

  useEffect(() => {
    const consentMode = JSON.parse(localStorage.getItem("consentMode"))

    if (consentMode) {
      const expiryDate = Date.parse(consentMode.expiry)

      if (Date.now() < expiryDate) {
        setShouldLoadGtm(true)

        // 🔴 THIS IS WHERE POINT 3 GOES
        if (domainZone === "it") {
          if (consentMode.ad_storage === "granted") {
            loadMarketingScript()
          }
        }

        return
      }
    }

    setShowConsent(true)
  }, [])

  return {
    showConsent,
    shouldLoadGtm,
    accept
  }
}

const { REACT_APP_DOMAIN_ZONE: _domainZone } = process.env
const getLocale = () => (_domainZone === "cl" || _domainZone === "it" ? _domainZone : null)

const getContentSection = section => {
  if (section) {
    if (section.type === "banner") {
      return {
        label: "",
        text: section.attributes?.description,
        image: section.attributes?.images?.background?.url,
        imageAlt: section.attributes?.images?.background?.alt || "",
        ctaText: section.attributes?.actions?.primary?.text,
        ctaLink: section.attributes?.actions?.primary?.url
      }
    }
    return {
      label: "",
      text: section.content
    }
  }
  return {}
}

const debounce = (fn, delay) => {
  let timeout

  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export async function graphqlRequest(query, variables = {}) {
  const userAgent = isMobile
    ? "Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.38 (KHTML, like Gecko) Version/11.0 Mobile/15A372 Safari/604.1"
    : "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/78.0.3904.108 Safari/537.36"

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-operator": siteCode,
      "x-language": domainZone,
      "x-market": marketUId,
      "User-Agent": userAgent,
      geoip_country_code: domainZone,
      invoker: lobbyUrl
    },
    body: JSON.stringify({ query, variables })
  })

  const json = await response.json()
  if (json.errors) throw new Error(json.errors[0].message)
  return json.data
}

const checkImage = url => {
  return new Promise(resolve => {
    const img = new Image()

    img.onload = () => resolve(true) // exists
    img.onerror = () => resolve(false) // 404 or bad file

    img.src = url
  })
}

export {
  getPage,
  pushDatalayer,
  addGtag,
  addGtm,
  loadingHandler,
  loadingEvent,
  handleSuccess,
  handleError,
  isUrl,
  getFont,
  getBannerFont,
  getLang,
  getTranslations,
  getMenuIcon,
  useCookieConsent,
  getCleanObject,
  getLocale,
  removeLeadingSlash,
  getContentSection,
  debounce,
  checkImage
}
